import { LoadingOutlined } from '@ant-design/icons'
import { Input, message, Modal, Select, Spin } from 'antd'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import DynamicTable from '../../../Components/TableComponents/DynamicTable'
import { getTicketCategory, updateTicketCategory } from '../../../Services/LocomotiveServices'

const TicketCategoryModals = ({ open, close, ticket_id, modalData, setReloadState: reload }) => {

    const [loader, setLoader] = useState(false)
    const [categories, setCategories] = useState([])
    const [selectedOption, setSelectedOption] = useState(undefined)

    const getTicketCategories = async () => {

        setLoader(true)
        const result = await getTicketCategory(4)
        if (result?.httpStatus === 200) {
            const data = result?.data.map(item => {
                return {
                    label: item?.name,
                    value: item?.id
                }
            })
            setCategories(data)
            setLoader(false)
        }
        setLoader(false)
    }

    useEffect(() => {
        if (open) {
            getTicketCategories()
            setSelectedOption(modalData?.values?.Ticket?.TicketCategory?.id || undefined)
        }
    }, [open])

    const onClickSave = async () => {
        let res = await updateTicketCategory(ticket_id, { TicketCategoryId: selectedOption })
        if (res?.httpStatus === 200) {
            message.success('Category Updated Successfully!')
            close()
            reload(prev => prev = !prev)
        }
    }

    return (
        <Modal
            open={open}
            onCancel={() => {
                close()
            }}
            footer={null}
            title="Update Ticket Category"
        >
            <Spin
                spinning={loader || false}
                indicator={<LoadingOutlined
                    style={{
                        fontSize: 24,
                    }}
                    spin
                />}>
                <div style={{ display: "flex", flexDirection: "column", gap: "25px" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "30% 70%", alignItems: "center" }}>
                            <span style={{ fontSize: "13px" }}>Ticket Category</span>
                            <Select
                                value={selectedOption}
                                showSearch
                                filterOption={(inputValue, option) => option.children ? option.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 : null}
                                onChange={e => setSelectedOption(e)}
                                placeholder='Select Option'
                            >
                                {
                                    categories?.map(({ value, label }) => (
                                        <Select.Option value={value}>{label}</Select.Option>
                                    ))
                                }
                            </Select>
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <button
                            style={{ background: "#2863AD", color: "white", padding: "10px 20px", border: "none", borderRadius: "10px", cursor: "pointer", opacity: selectedOption ? "1" : "0.4" }}
                            onClick={onClickSave}
                            disabled={selectedOption ? false : true}
                        >
                            Update
                        </button>
                    </div>
                </div>
            </Spin>
        </Modal>
    )
}

export default TicketCategoryModals